module.exports = __webpack_public_path__ + "static/img/6c820ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/simulate/images/ios.png
// module id = 694
// module chunks = 2